import { axios, base } from '../http';

/** 班牌 MQTT 设备流水分页 */
export const getMqttDeviceLogPage = (params) => {
  return axios.get(`${base}/api/MqttDeviceLog/GetPage`, { params });
};

/** 按需获取单条 MQTT 流水正文 */
export const getMqttDeviceLogDetail = (id, createTime) => {
  return axios.get(`${base}/api/MqttDeviceLog/GetDetail`, { params: { id, createTime } });
};
